import {post, get} from './request'

let skApi =  'https://api.dellemc-solution.com'
let api = {
    install(Vue) {
        Vue.prototype.$api = api;
    },

    // 获取作品列表
    worksList: (page, page_size, orderType) => get('/api/match/works', {
        params: {
            page: page,
            page_size:page_size,
            order_type: orderType
        }
    }),

    //登出
    logout:() => post('/api/account/logout'),

    //作品详情
    workData: (workId, session, OCSESSID) => get('/api/match/work', {
        params: {
            work_id: workId,
            "session": session,
            "OCSESSID": OCSESSID,
        }
    }),


    //注册或者登录
    loginAndRegister: (unique, checkCode) => post('/api/account/loginAndRegister', {
        data: {
            "unique": unique,
            "checkCode": checkCode,
            "moduleSource": '',
            "utmSource": ''
        }
    }),

    //作品作者 用户上传修改的回填
    getAuthor: (session, OCSESSID) => post('/api/match/author', {
        data: {
            "session": session,
            "OCSESSID": OCSESSID,
        }
    }),

    //获取验证码
    sendcode: (unique, action = 'all') => post('/api/account/sendcode', {
        data: {
            "formId": '1430',
            "action": action,
            "unique": unique,
        }
    }),

    //投票
    getVote: (workId, session, OCSESSID) => post('/api/match/vote', {
        data: {
            "work_id": workId,
            "session": session,
            "OCSESSID": OCSESSID,
        }
    }),

    //投过的票
    getVoted: (range, session, OCSESSID) => get('/api/match/voted', {
        params: {
            range: range,
            session: session,
            OCSESSID: OCSESSID,
        }
    }),

    //地区三级级联表
    getRegions: (pid, level) => get('/api/regions/get', {
        params: {
            pid: pid,
            level: level,
        }
    }),

    //作品上传
    getUpload: (data) => post('/api/match/upload', {
        data: data
    }),

    //上传图片
    getUpImg: (formData) => post('/api/match/upimg', {
        data: formData
    }),

    //我的作品
    getMyWork: (session, OCSESSID) => post('/api/match/mywork', {
        data: {
            "session": session,
            "OCSESSID": OCSESSID,
        }
    }),

    //验证用户是否注册
    checkUnique: (mobile) => post('/api/account/checkUnique', {
        data: {
            "mobile": mobile
        }
    }),

    // 获取用户信息
    getUserInfo: (globalUserId, sess) => post(skApi + '/member/LookUp', {
        data: {
            globalUserId: globalUserId,
            sess: sess,
        }
    }),

    // 获取微信配置信息
    getWxConfig: (data) => post(skApi + '/weChat/getConfig', {
        data: data
    }),

    // 下载文件发送邮件
    sendFileEmail: (data) => post(skApi + '/file/downloadWithEmail', {
        data: data
    }),

};
export default api;
